var $ = require('jquery'),
    Class = require('Class'),
    Events = require('Events'),
    Utils = require('Utils'),
    Model         = require("Model"),
    Collection    = require("Collection");


/**
 * @class omjs
 * @static
 */
var omjs = {
    /**
     * Версия API
     *
     * @private
     */
    version: "2.6"
};


/**
 *
 */
omjs.$ = $;

omjs.Class = Class;
omjs.Events = Events;
omjs.Utils = Utils;
omjs.Access = require('Access');

/**
 * {{#crossLink "omjs.Model"}} Описание класса omjs.Model {{/crossLink}}
 *
 * @property {omjs.Model} Model
 */
omjs.Model = Model;

/**
 * {{#crossLink "omjs.Collection"}} Описание класса omjs.Collection{{/crossLink}}
 *
 * @property {omjs.Collection} Collection
 */
omjs.Collection = Collection;

module.exports = omjs;



//////////////////
// WEBPACK FOOTER
// ./src/omjs.js
// module id = 2
// module chunks = 0